export default "__VITE_ASSET__CPr_AztR__"